var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{header}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<span ng-bind-html=\"message\"></span>\n<div ng-if=\"errorMessage\">\n{{errorMessage}}\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-{{type}}\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-disabled=\"isLoading\" ng-click=\"ok()\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loading}\"></span> {{ buttons[0] | translate }}\n</button>\n<button ng-if=\"buttons.length == 2\" class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">\n{{ buttons[1] | translate }}\n</button>\n</div> ";
var id1="modal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/common/ui/modal/modal.html
// module id = 2499
// module chunks = 1